// Image performance helpers: serve Unsplash images as next-gen WebP at a sensible
// width, and provide width/height attributes so the browser reserves space (less CLS).

export const webp = (url, w) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('images.unsplash.com')) return url;
  let out = url;
  if (/[?&]fm=(jpg|jpeg|png)/i.test(out)) {
    out = out.replace(/([?&])fm=(jpg|jpeg|png)/i, '$1fm=webp');
  } else if (!/[?&]fm=/.test(out)) {
    out += (out.includes('?') ? '&' : '?') + 'fm=webp';
  }
  if (w && !/[?&]w=/.test(out)) out += `&w=${w}`;
  return out;
};

// Standard props for an offscreen image inside a fixed-ratio container.
// width/height are aspect-ratio hints (CSS still controls displayed size).
export const imgProps = (url, w = 600, h = 400) => ({
  src: webp(url, w),
  loading: 'lazy',
  decoding: 'async',
  width: w,
  height: h,
});
